import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
} from 'react-router-dom'

import ReactGA from 'react-ga';
import './App.css';

import ArtsAndCulture from './pages/ArtsAndCulture/'
import ArticleRedesign from './pages/ArticleRedesign/'
import Colophon from './pages/Colophon/'
import Home from './pages/Home/'
import RemoteRetro from './pages/RemoteRetro/'

class App extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');

    return (
      <Router>
        <div>
          <div className="grid">
            <header>
              <h1><Link to="/">Mark Cipolla</Link></h1>
              <h2>Designer &amp; Developer</h2>
            </header>
          </div>

          <Route exact path="/article-redesign" component={ ArticleRedesign } />
          <Route exact path="/arts-and-culture" component={ ArtsAndCulture } />
          <Route exact path="/remoteretro" component={ RemoteRetro } />
          <Route exact path="/colophon" component={ Colophon } />

          <Route exact path="/" component={ Home } />

          <div className="grid">
            <footer>
              <div className="grid-item">
                <div className="element">
                  <ul>
                    <li><a href="mailto:mark@markcipolla.com">mark@markcipolla.com</a></li>
                  </ul>
                </div>

                <div className="element">
                  <ul className="secondary">
                    <li><Link to="/colophon">Colophon</Link></li>
                  </ul>
                </div>
              </div>

              <div className="grid-item three-grid-item-prepend-one four-grid-item-prepend-two five-grid-item-prepend-three">
                <div className="element">
                  <ul>
                    <li><a href="https://twitter.com/markcipolla">Twitter</a></li>
                    <li><a href="https://github.com/markcipolla">Github</a></li>
                  </ul>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </Router>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js